import React, { ReactNode } from 'react';
import { styled } from '@linaria/react';
import { Icon } from '../Icon';
import { Text, TextVariant } from '../Text';
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Whether the checkbox is checked or not */
  checked: boolean;
  /** Whether the checkbox is disabled or not */
  disabled?: boolean;
  /** Whether the input has an error */
  hasError?: boolean;
  /** Content to render in label next to the checkbox */
  label?: ReactNode;
  /** Name used for html input element */
  name: string;
  /** The Checkbox change handler. Fires when user change state of Checkbox */
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Value used for html input element */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  /** Use larger touch area */
  hasTouchArea?: boolean;
  /** Label size */
  labelSize?: Extract<TextVariant, 'bodyM' | 'bodyS'>;
}
const CheckboxElement = /*#__PURE__*/styled('div')({
  name: "CheckboxElement",
  class: "c12fa8mf",
  propsAsIs: false
});
export const CheckboxContent = /*#__PURE__*/styled('div')({
  name: "CheckboxContent",
  class: "c1kb8iep",
  propsAsIs: false
});
export const CheckboxIcon = /*#__PURE__*/styled('span')({
  name: "CheckboxIcon",
  class: "c2jcvqq",
  propsAsIs: false
});
export const CheckboxInput = /*#__PURE__*/styled('input')({
  name: "CheckboxInput",
  class: "cgara7p",
  propsAsIs: false
});
const _exp32 = /*#__PURE__*/() => ({
  hasTouchArea
}) => hasTouchArea ? 12 : 2;
export const CheckboxBody = /*#__PURE__*/styled('label')({
  name: "CheckboxBody",
  class: "c3j83pg",
  propsAsIs: false,
  vars: {
    "c3j83pg-0": [_exp32(), "px"]
  }
});
const _exp44 = /*#__PURE__*/() => Text;
const StyledText = /*#__PURE__*/styled(_exp44())({
  name: "StyledText",
  class: "s1ny4o76",
  propsAsIs: true
});
export const Checkbox = ({
  checked,
  value,
  name,
  dataId,
  onChange,
  label,
  disabled,
  hasError = false,
  hasTouchArea = false,
  className,
  labelSize = 'bodyS'
}: Props) => <CheckboxElement className={className}>
    <CheckboxBody hasTouchArea={hasTouchArea}>
      <CheckboxInput type="checkbox" name={name} data-id={dataId} checked={checked} value={value} disabled={disabled} data-field-error={hasError} onChange={onChange} />
      <CheckboxIcon>
        <Icon name="Checkmark" size="sm" />
      </CheckboxIcon>
      {Boolean(label) && <CheckboxContent>
          <StyledText variant={labelSize}>{label}</StyledText>
        </CheckboxContent>}
    </CheckboxBody>
  </CheckboxElement>;

require("./Checkbox.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Checkbox.tsx");